import { environment } from '../config/environment';
import { useApiClient } from './api';

export const useHelpscoutService = () => {
    const apiClient = useApiClient();

    const requestIndividualSetup = async (): Promise<any> => {
        const response = await apiClient.post(`${environment.expressApiUrl}/api/support/request-consultation`, {});
        return response.data;
    };

    return { requestIndividualSetup };
};
